import { render, staticRenderFns } from "./BaseNormalSoundButton.vue?vue&type=template&id=66dbd6eb&"
import script from "./BaseNormalSoundButton.vue?vue&type=script&lang=ts&"
export * from "./BaseNormalSoundButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports